import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#4D4C4A] text-white py-16 border-t border-white/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="space-y-6 md:col-span-1">
            <div className="flex items-center space-x-3">
              <div className="w-12 h-12 bg-[#91756A] rounded-sm flex items-center justify-center">
                <span className="text-white font-bold text-xl">V</span>
              </div>
              <div>
                <h3 className="text-2xl font-bold tracking-tighter italic">VASTECH</h3>
                <p className="text-xs text-white/50 uppercase tracking-widest">Engineering Excellence</p>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Leading engineering solutions provider specializing in advanced HVAC, smart elevators, and intelligent building technologies.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-6 text-white/40">Solutions</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/elevator-solutions" className="hover:text-[#91756A] transition-colors duration-300">Elevator Solutions</Link></li>
              <li><Link to="/ac-maintenance-services" className="hover:text-[#91756A] transition-colors duration-300">HVAC & Cooling</Link></li>
              <li><Link to="/smart-home-services" className="hover:text-[#91756A] transition-colors duration-300">Smart Integration</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-6 text-white/40">Company</h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><Link to="/about-vastech" className="hover:text-[#91756A] transition-colors duration-300">About VASTECH</Link></li>
              <li><Link to="/project-portfolio" className="hover:text-[#91756A] transition-colors duration-300">Project Portfolio</Link></li>
              <li><Link to="/contact-consultation" className="hover:text-[#91756A] transition-colors duration-300">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-widest mb-6 text-white/40">Connect</h4>
            <div className="space-y-3 text-sm text-white/70">
              <p className="flex items-center space-x-2">
                <span className="text-[#91756A]">T:</span>
                <span>+971 5444 111 79</span>
              </p>
              <p className="flex items-center space-x-2">
                <span className="text-[#91756A]">E:</span>
                <span>info@vastech.ae</span>
              </p>
              <p className="text-white/40 mt-4 italic">Sharjah, United Arab Emirates</p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/30 uppercase tracking-widest">
          <p className="text-center md:text-left">&copy; {new Date()?.getFullYear()} VASTECH Solutions. All rights reserved.</p>
          <div className="flex space-x-6">
            <Link to="#" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;